/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Casmanagement_Table_Fund1Inputs */

const en_settings_casmanagement_table_fund1 = /** @type {(inputs: Settings_Casmanagement_Table_Fund1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fund`)
};

/**
* | output |
* | --- |
* | "Fund" |
*
* @param {Settings_Casmanagement_Table_Fund1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_casmanagement_table_fund1 = /** @type {((inputs?: Settings_Casmanagement_Table_Fund1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Casmanagement_Table_Fund1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_casmanagement_table_fund1(inputs)
});
export { settings_casmanagement_table_fund1 as "settings_casManagement_table_fund" }